import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var UrySVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0038A8",
  d: "M0 27a4 4 0 004 4h28a4 4 0 004-4v-1H0v1zm0-8h36v4H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M0 23h36v3H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0038A8",
  d: "M36 9a4 4 0 00-4-4H16v4h20zm-20 3h20v4H16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M16 9V5H4a4 4 0 00-4 4v10h36v-3H16v-4h20V9H16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD983",
  d: "M13 12a5 5 0 10-10 0 5 5 0 0010 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC4D",
  d: "M12 12a4 4 0 10-8 0 4 4 0 008 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAC33",
  d: "M8 5.597l.633 4.041 2.569-3.183-1.473 3.816 3.816-1.473-3.183 2.569 4.041.633-4.041.633 3.183 2.569-3.816-1.473 1.473 3.816-2.569-3.183L8 18.403l-.633-4.041-2.569 3.183 1.473-3.816-3.816 1.473 3.183-2.569L1.597 12l4.041-.633-3.183-2.569 3.816 1.473-1.473-3.816 2.569 3.183z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C1694F",
  d: "M11 12a3 3 0 10-6 0 3 3 0 006 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAC33",
  d: "M5.834 12.004a2.153 2.153 0 114.307-.001 2.153 2.153 0 01-4.307.001z"
})));

export { UrySVG as default };
//# sourceMappingURL=bundle.esm11.js.map
